import { BaseService } from "./BaseService";

export class DailyUpdateService extends BaseService {
  getDailyUpdateLetter(idLog) {
    return this.request(`api/DailyUpdate/GetDailyUpdateLetter/${idLog}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }
}

const dailyUpdateService = new DailyUpdateService();

export default dailyUpdateService;
